const classes = {
  hoverEffects: {
    '&:hover': {
      opacity: 0.8
    }
  }
}

export default classes
